export default __webpack_public_path__ + "static/saymore-72b3847100326315c40be1e2944acda5.png";